// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import {DropdownButton} from 'ui'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ShareButton from './ShareButton'
import Button from '@mui/material/Button';
import { useAIChat } from '../contexts/AIChatContext';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { AI_PRIMARY, AI_PRIMARY_DARK, AI_PRIMARY_LIGHT } from '../../../utils/themeColors';

// Convert to functional component to use hooks
const HeaderDropdown = (props) => {
  const { openChat, closeChat, isOpen } = useAIChat();
  const location = useLocation();

  // Check if we're on a transcript route
  const isTranscriptRoute = location.pathname.startsWith('/transcripts/');

  // Show AI Chat button only on transcript routes AND with edit permission
  const showAIChat = isTranscriptRoute && props.hasEditPermission;

  const handleChatClick = () => {
    if (isOpen) {
      closeChat();
    } else {
      openChat();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        float: 'right'
      }}
    >
      {showAIChat && (
        <Button
          variant="outlined"
          onClick={handleChatClick}
          sx={{
            minWidth: 'auto',
            padding: '4px 8px',
            fontSize: '14px',
            height: 32,
            whiteSpace: 'nowrap',
            textTransform: 'none',
            color: AI_PRIMARY,
            borderColor: AI_PRIMARY,
            '&:hover': {
              borderColor: AI_PRIMARY_DARK,
              backgroundColor: AI_PRIMARY_LIGHT
            }
          }}
        >
          AI
        </Button>
      )}

      <ShareButton
        hasEditPermission={props.hasEditPermission}
        onShowCollabModal={props.onShowCollabModal}
        showCollabModal={props.showCollabModal}
      />
      
      <DropdownButton
        variant="link"
        title={<MoreHorizIcon data-testid="MoreHorizIcon" style={{color:"black", fontSize: '20px', verticalAlign: 'middle'}}/>}
        id={1}
        noCaret
        pullRight
      >
        {props.children}
      </DropdownButton>
    </Box>
  );
};

export default HeaderDropdown;
